import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

/* 문서 메타 헤더 — 제목/발행사/일자. 본문과 구분선으로 분리. */
export const metaStyle = css`
  padding-bottom: ${theme.space.md}px;
  margin-bottom: ${theme.space.md}px;
  border-bottom: 1px solid ${theme.color.border};
`;

export const titleStyle = css`
  margin: 0 0 ${theme.space.xs}px;
  font-size: ${theme.fontSize.lg}px;
  font-weight: 600;
  color: ${theme.color.text};
  line-height: 1.4;
`;

/* 발행사 · 일자 등 부가 정보 한 줄. */
export const submetaStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.space.sm}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

export const actionsStyle = css`
  display: flex;
  gap: ${theme.space.sm}px;
  margin-top: ${theme.space.md}px;
`;

/* 로딩/에러/폴백 안내 박스. */
export const msgStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  padding: ${theme.space.lg}px 0;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

/* 엔드포인트 미배포 등으로 본문을 못 받았을 때의 안내 — 원본 PDF로 유도. */
export const fallbackStyle = css`
  padding: ${theme.space.md}px;
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.md}px;
  background: ${theme.color.primarySoft};
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.text};
  line-height: 1.6;
`;

/**
 * 마크다운 본문 영역.
 * 변환 결과라 표·이미지가 섞여 있다 — 이미지는 폭에 맞추고, 표는 넘치면 가로 스크롤.
 */
export const mdStyle = css`
  font-size: ${theme.fontSize.md}px;
  line-height: 1.7;
  color: ${theme.color.text};
  word-break: break-word;

  h1,
  h2,
  h3,
  h4 {
    margin: ${theme.space.lg}px 0 ${theme.space.sm}px;
    line-height: 1.4;
  }
  h1 {
    font-size: ${theme.fontSize.xl}px;
  }
  h2 {
    font-size: ${theme.fontSize.lg}px;
  }
  h3,
  h4 {
    font-size: ${theme.fontSize.md}px;
  }

  p {
    margin: 0 0 ${theme.space.md}px;
  }

  /* 변환 이미지 — 실적 차트/표 캡처. 폭 초과 방지. */
  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: ${theme.space.md}px 0;
    border: 1px solid ${theme.color.border};
    border-radius: ${theme.radius.sm}px;
  }

  /* 표는 폭이 큰 경우가 많아 래퍼 없이도 넘치지 않게 처리. */
  table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
    border-collapse: collapse;
    margin: ${theme.space.md}px 0;
    font-size: ${theme.fontSize.sm}px;
  }
  th,
  td {
    border: 1px solid ${theme.color.border};
    padding: 6px 10px;
    text-align: left;
    white-space: nowrap;
  }
  th {
    background: ${theme.color.bg};
    font-weight: 600;
  }

  code {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: ${theme.fontSize.sm}px;
    background: ${theme.color.bg};
    padding: 1px 4px;
    border-radius: ${theme.radius.sm}px;
  }

  pre {
    overflow-x: auto;
    background: ${theme.color.bg};
    padding: ${theme.space.sm}px;
    border-radius: ${theme.radius.sm}px;
  }

  blockquote {
    margin: ${theme.space.md}px 0;
    padding-left: ${theme.space.md}px;
    border-left: 3px solid ${theme.color.border};
    color: ${theme.color.textMuted};
  }

  ul,
  ol {
    margin: 0 0 ${theme.space.md}px;
    padding-left: ${theme.space.lg}px;
  }

  a {
    color: ${theme.color.primary};
  }
`;
